import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from '../store';
import EditFaceDialog from '../components/EditFaceDialog';

/** Show Revision required fields dialog */
export default function showEditFaceDialog(props) {
  const $wrapper = document.createElement('div');
  $wrapper.classList.add('wrapperDialog');
  $wrapper.classList.add('exportDialogWrapper');
  const $container = document.querySelector('#dialogRoot') || document.body;
  $container.appendChild($wrapper);
  const root = createRoot($wrapper);

  function destroy() {
    root.unmount();
    if ($wrapper.parentNode === $container) {
      $container.removeChild($wrapper);
    }
  }
  root.render(
    <Provider store={store}>
      <EditFaceDialog destroy={destroy} {...props} />
    </Provider>,
  );
}
